import React, { useState, useEffect, useContext} from "react";
import Axios from "axios";
import firebase from "firebase/app";

import {
    Row,
    Container,
    Col,
    Table ,
} from "reactstrap";

import { useHistory } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { toast } from "react-toastify";
import AdminNav from "../layout/AdminNav"

export default function Feedbacks() {
    const context = useContext(UserContext);
    const [contactData, setContactData] = useState([]);
    const [feedbackData, setFeedbackData] = useState([]);
    const [users, setUsers] = useState([]);
    const history = useHistory();
    let uniqueUser = {};

    const fetchDetails = async () => {
        try {
            setContactData([])
            setUsers([]);
            firebase.database().ref('Contact').on('value',   function(snapshot) {
                snapshot.forEach(function(childSnapshot) {
                    var tempData = [];
                    var tempUsers = [];
                    let data = childSnapshot.val();
                    tempData.push(data);
                    setContactData((prevData) => {
                        return [...prevData,...tempData]
                    });


                    if(!uniqueUser[data.email]){
                        uniqueUser[data.email] = {}
                        tempUsers.push(data.email);
                        setUsers((prevData) => {
                            return [...prevData,...tempUsers]
                        });
                    }

                    console.log(users)
            })});
            firebase.database().ref('Feedback').on('value',   function(snapshot) {
                snapshot.forEach(function(childSnapshot) {
                    var tempData = [];
                    var tempUsers = [];
                    let data = childSnapshot.val();
                    tempData.push(data);
                    setFeedbackData((prevData) => {
                        return [...prevData,...tempData]
                    });
            })});
            
        } catch (error) {
            toast("Not able to locate user", { type: "error" });
        }
    };

    useEffect(() =>{
        let authData = localStorage.getItem("auth");
        if(!authData){
            history.push("/pageNotFound");
        }
        fetchDetails();
    },[])
    //put anypage behind login

    return (
        <>
            <Row className="mt-3">
                <Col md="2"> 
                    <AdminNav active="feedbacks"/>
                </Col>
                <Col md="10" style={{marginLeft : "350px"}}>
                    <Row>
                        <Col md="12">
                           <Row>
                               <Col md="3">
                                    <div className="widget style1" style={{background:"#437187", color:"#fff"}}>
                                        <div className="row">
                                            <div className="col-4">
                                                <i className="fa fa-envelope fa-5x"></i>
                                            </div>
                                            <div className="col-8" style={{textAlign:"right"}}>
                                                <span> Total massages </span>
                                                <h2 className="font-bold">{contactData.length}</h2>
                                            </div>
                                        </div>
                                    </div>
                               </Col>
                               <Col md="3">
                                    <div className="widget style1" style={{background:"#437187", color:"#fff"}}>
                                        <div className="row">
                                            <div className="col-4">
                                                <i className="fa fa-user fa-5x"></i>
                                            </div>
                                            <div className="col-8" style={{textAlign:"right"}}>
                                                <span> Total users </span>
                                                <h2 className="font-bold">{users.length}</h2>
                                            </div>
                                        </div>
                                    </div>
                               </Col>
                               <Col md="3">
                                    <div className="widget style1" style={{background:"#437187", color:"#fff"}}>
                                        <div className="row">
                                            <div className="col-4">
                                                <i className="fa fa-user fa-5x"></i>
                                            </div>
                                            <div className="col-8" style={{textAlign:"right"}}>
                                                <span> Total Feedbacks</span>
                                                <h2 className="font-bold">{feedbackData.length}</h2>
                                            </div>
                                        </div>
                                    </div>
                               </Col>
                           </Row>
                        </Col>
                    </Row>
                    <Row style={{marginRight : "100px"}}>
                        <Col md="12">
                            <div className="ibox">
                                <div className="ibox-title input-group-append">
                                    <h4 style={{marginTop: "7px", width: "150px"}}>Feedbacks</h4>
                                </div>
                                <div  className="ibox-content">
                                    <Table className="table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Rate</th>
                                                <th>Comment</th>
                                                <th>Uploaded Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                feedbackData.map((value) =>{
                                                    return <tr><td>{value.name}</td><td>{value.subject}</td><td>{value.rateCount}</td><td>{value.comment}</td><td>{value.uploadedDate}</td></tr>
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );
}
